import { Box, Typography } from "@mui/material";

export interface UWReviewIdentifier {
  label: string;
  value: string;
}

export function UWReviewPolicyIdentifiers({
  identifiers,
  fontSize = 18,
}: {
  identifiers: UWReviewIdentifier[];
  fontSize?: number;
}) {
  return (
    <Box mb={5}>
      {identifiers.map(({ label, value }) => (
        <Typography key={label} fontSize={fontSize}>
          <Typography component="span" fontWeight={500} fontSize={fontSize}>
            {label}:{" "}
          </Typography>
          {value}
        </Typography>
      ))}
    </Box>
  );
}
